// Load the single populated scenes file via alias
import scenesById from "@marble_scenes.populated.json";

// Convert to a record keyed by id
export const WORLDS = {
  ...Object.fromEntries(
      Object.entries(scenesById).map(([id, scene]) => [
        id,
        {
          name: scene.name,
          thumbnail: "https://cdn.marble.worldlabs.ai/" + scene.image_prompt_uri,
          scene: {
            sceneType: "marble",
            sceneId: id,
            collisionId: "https://cdn.marble.worldlabs.ai/" + scene.collider_mesh_uri,
          },
        },
      ]),
    )
};